import React from "react";

// import each file at the top:
import niv1 from "../../assets/doc/ANGLAIS-PRO__RESTAURATION-ET-HÔTELLERIE-Niv1.pdf";
import niv2 from "../../assets/doc/ANGLAIS-PRO__RESTAURATION-ET-HÔTELLERIE-Niv2.pdf";
import angPro from "../../assets/doc/Anglais-Professionnel.pdf";
import fleA1 from "../../assets/doc/Français-FLE-Niveau-A1.pdf";
import fleA2 from "../../assets/doc/Français-FLE-Niveau-A2.pdf";
import CompDigi from "../../assets/doc/bureautique_sur_mesure_2025UP4MIND.pdf";
import BazWP from "../../assets/doc/programme_maitriser_bases_WP_UP4MIND_2025.pdf";
import IntroWP from "../../assets/doc/programme_introduction_bases_WP_UP4MIND_2026.pdf";
import RenfoBur from "../../assets/doc/programme_renforcement_bureautique_UP4MIND_2025.pdf";

const Programme = () => {
  function Documents({ text, file }) {
    return (
      <a
        href={file}
        className="formations-pdf"
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        <p>{text}</p>
      </a>
    );
  }

  return (
    <section className="formation-programme" id="formation-programme">
      <h2>
        TÉLÉCHARGEZ NOS <span>PROGRAMMES</span>
      </h2>
      <ul>
        <Documents
          text="ANGLAIS PRO – RESTAURATION & L’HÔTELLERIE NIV 1"
          file={niv1}
        />
        <Documents
          text="ANGLAIS PRO – RESTAURATION & L’HÔTELLERIE NIV 2"
          file={niv2}
        />
        <Documents
          text="ANGLAIS PROFESSIONNEL"
          file={angPro}
        />
        <Documents
          text="FRANÇAIS FLE NIVEAU A1"
          file={fleA1}
        />
        <Documents
          text="FRANÇAIS FLE NIVEAU A2"
          file={fleA2}
        />
        <Documents
          text="COMPÉTENCES BUREAUTIQUE ET DIGITALE"
          file={CompDigi}
        />
        <Documents 
          text="LES BASES DE WORDPRESS"
          file={BazWP}
        />
        <Documents
          text="INTRODUCTION AUX BASES DE WORDPRESS"
          file={IntroWP}
        />
        <Documents 
          text="RENFORCEMENT BUREAUTIQUE"
          file={RenfoBur}
        />
      </ul>
    </section>
  );
};

export default Programme;
